import { Component, Input } from '@angular/core';
import { Approval } from 'app/models/dto/approval/approval.model';
import { Application } from 'app/models/dto/deal-application.model';
import { Deal } from 'app/models/dto/deal.model';

@Component({
  selector: 'app-advanced-deal-details',
  templateUrl: './details.component.html',
  standalone: false
})
export class AdvancedDealDetailsComponent {
    @Input() applications: Application[] = [];
    @Input() closerName: string = '';
    @Input() approvals: Approval[] = [];
    @Input() deal: Deal;
    @Input() readOnly: boolean = false;
  constructor(){}
}
